import Controller from "../controller/Controller";
import {ApplePayHandler} from "./ApplePayHandler";
import {MethodDataHandler} from "./MethodDataHandler";
import {deepCopy} from "../../utils/deepCopy";
import {PaymentRequestMockForUnsupportedBrowser} from "./PaymentRequestMockForUnsupportedBrowser";
import {PaymentRequestFactoryOptions} from "../types/SecurionPayOptions";
import { GooglePayHandler } from "./GooglePayHandler";

export class PaymentRequestFactory {
    private readonly _methodDataHandlers: MethodDataHandler[];

    constructor(_controller: Controller, _publicKey: string, options: PaymentRequestFactoryOptions) {
        this._methodDataHandlers = [
            new ApplePayHandler(_controller, options),
            new GooglePayHandler(_publicKey),
        ];
    }

    createPaymentRequest = (
        methodsData: PaymentMethodData[],
        paymentDetails: PaymentDetailsInit,
        paymentOptions: PaymentOptions = {}
    ): PaymentRequest => {
        if (!window.PaymentRequest) {
            return new PaymentRequestMockForUnsupportedBrowser(methodsData, paymentDetails)
        }
        const enhancedMethodData: PaymentMethodData[] = deepCopy(methodsData)
        const enhancedPaymentDetails: PaymentDetailsInit = deepCopy(paymentDetails)
        this._methodDataHandlers.forEach(handler => {
            enhancedMethodData.forEach(method => handler.enhanceMethod(method, enhancedPaymentDetails));
        
        })
        
        const paymentRequest = new PaymentRequest(
          enhancedMethodData,
          enhancedPaymentDetails,
          paymentOptions
        );

        this._methodDataHandlers.forEach(enhancer => enhancer.enhancePaymentRequest(paymentRequest, enhancedMethodData, enhancedPaymentDetails))
        return paymentRequest;
    }
}